module.exports = __webpack_public_path__ + "img/fundas-02.4098a834.png";